/* istanbul ignore file */
import { combineReducers } from 'redux';
import { persistToLocalStorage, persistToSessionStorage } from '@nike/ux-tread-web-storage';

import warningsReducer from './warnings/reducer';
import errorsReducer from './errors/reducer';
import locationReducer from './location/reducer';
import normalizedReducer from './normalized/reducer';
import shopUiReducer from './ui/reducer';
import sharedStateReducer from './shared/reducer';
import promosReducer from './promos/reducer';

import locationStateReconciler from './location/state-reconciler';

export default combineReducers({
  warnings: warningsReducer,
  errors: errorsReducer,
  location: persistToLocalStorage('location', locationReducer, {
    stateReconciler: locationStateReconciler,
  }),
  normalized: persistToSessionStorage('normalized', normalizedReducer, {
    blacklist: ['promoCodes'],
  }),
  ui: shopUiReducer,
  shared: persistToLocalStorage('shared', sharedStateReducer),
  promos: promosReducer,
});
